import React, { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import FormFields from './form/FormFields';
import { deprovisionValidation } from './form/schemas/deprovisionValidationSchema';
import { triggerNotification, useGetApiRequests, useNavigate } from '../../../../../../common/CommonExport';
import dayjs from 'dayjs';
import Loader from '../../../../../../components/Loader/Loader';

import {
  ApiError,
  DeprovisionFormMailProps,
  FormValues,
  QuestionDetail
} from './types/DeprovisionFormMailTypes';

const DeprovisionFormMail: React.FC<DeprovisionFormMailProps> = ({ exitFormFillDetails, exitFormFillData, questions, employeeApiKey, employeeId }) => {
  const navigate = useNavigate()
  const createExitInterView = useGetApiRequests('createExitInterView', 'POST');
  const [btnLoading, setBtnLoading] = useState<boolean>(false);
  const currentDate = dayjs()
  const [initialValues, setInitialValues] = useState<FormValues>({
    reviewtype: '',
    salaryRevised: '',
    incrementEligible: false,
    probationExtension: '',
    interviewBy: '',
    date: currentDate,
    typeOfExit: '',
    exitReason: '',
    appraiserComments: Array(questions.length).fill(''),
  }
  )

  useEffect(() => {
    const employeeRelievingDate = exitFormFillData?.employeeRelievingDate ? exitFormFillData?.employeeRelievingDate : currentDate;
    const date = dayjs(employeeRelievingDate);
    setInitialValues({
      ...initialValues,
      typeOfExit: exitFormFillData?.exitType || '',
      interviewBy: exitFormFillData?.hrName || '',
      date: date,
      exitReason: exitFormFillData?.exitReason || ''

    })
  }, [exitFormFillData])



  const martialStatus = [
    { label: 'Resignation', value: 'Resigned' },
    { label: 'Layoff', value: 'Layoff' },
    { label: 'Other', value: 'Other' },
    { label: 'Termination', value: 'Termination' }
  ];
  const handleSubmit = (values: FormValues) => {

    const payload = exitFormFillDetails.map((question: QuestionDetail, index: number) => {
      return {
        employeeId: employeeId,
        questionaire: {
          questionaireId: question?.questionaireId
        },
        answer: values?.appraiserComments[index]
      };

    });
    submitReview(payload)

  }

  const submitReview = (payload: { employeeId: string | number; questionaire: { questionaireId: number }; answer: string }[]) => {
    const queryString = {
      employeeApiKey: employeeApiKey,
      employeeReviewId: exitFormFillData?.exitReviewId
    }
    setBtnLoading(true);
    createExitInterView(payload, queryString).then(() => {
      setTimeout(() => {
        setBtnLoading(false);
        navigate('/exit-interview-success?message=You have successfully completed the exit interview');
      }, 1000)
    })
      .catch((err: ApiError) => {
        setBtnLoading(false);
        triggerNotification('error', '', err?.response?.data?.message || "Something went wrong!", 'topRight');
      });
  }

  useEffect(() => {
    if (btnLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [btnLoading]);

  return (
    <>
      {btnLoading && <Loader />}
      <div className="salary-date review-modal email-template">

        <Formik
          initialValues={initialValues}
          validationSchema={deprovisionValidation(questions)}
          onSubmit={handleSubmit} enableReinitialize
        >
          {({ values, setFieldValue, errors }) => {

            return (
              <Form>
                <FormFields
                  questions={exitFormFillDetails}
                  martialStatus={martialStatus}
                  values={values}
                  setFieldValue={setFieldValue}
                  errors={errors}
                />
                <div className="flex w-full justify-center items-center pt-10 lg:pt-20 pb-5 lg:pb-16">
                  <button
                    className="form-submit-btn text-white font-medium"
                    disabled={btnLoading}
                  >
                    {
                      btnLoading ? 'Submitting...' : 'Submit Application'
                    }
                  </button>
                </div>
              </Form>)
          }}
        </Formik>
      </div>
    </>
  );
};

export default DeprovisionFormMail;